var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"field__label"},[_vm._v("\n    "+_vm._s(this.$t('nutritionDetail.report.clouds'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"field__value"},[_c('DxNumberBox',{attrs:{"readOnly":true},model:{value:(_vm.cloudsData),callback:function ($$v) {_vm.cloudsData=$$v},expression:"cloudsData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }